import CryptoJS from "crypto-js";

export function encryptWithPassword(dataObj, password) {
  const json = JSON.stringify(dataObj);
  const encrypted = CryptoJS.AES.encrypt(json, password).toString();
  return encrypted;
}
